import React, { useEffect, useState } from "react";
import axios from "axios";

const AboutUs = () => {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadAbout() {
      try {
        const res = await axios.get(window.BASE_API_URL + "about");

        const list = res.data.data || [];
        const base = res.data.image_base_url || "";

        const obj = {};
        list.forEach((item) => {
          obj[item.name] = item.value;
        });

        obj.bg_status = res.data.bg_status;
        obj.fullBackgroundImage = obj.background_image
          ? base + obj.background_image
          : "";

        setAbout(obj);
        setLoading(false);
      } catch (error) {
        console.error("Error loading About Us:", error);
        setLoading(false);
      }
    }

    loadAbout();
  }, []);

  if (loading || !about) {
    return (
      <div className="text-center py-20 text-xl font-semibold text-gray-600">
        Loading About Us...
      </div>
    );
  }

  // 🟣 Background selection logic
  const sectionStyle =
    about.bg_status == 1
      ? { backgroundImage: `url(${about.fullBackgroundImage})` }
      : { backgroundColor: about.background_color || "#000000" };

  // 🟣 Card transparent black background
  const cardBackground = "rgba(0, 0, 0, 0.7)";

  return (
    <section
      className="w-full mt-3 min-h-[80vh] flex items-center justify-center px-4 py-20 bg-cover bg-center relative"
      style={sectionStyle}
    >
      {/* overlay only if using image */}
      {about.bg_status == 1 && (
        <div className="absolute inset-0 bg-black/45 backdrop-blur-[2px]"></div>
      )}

      <div
        className="relative z-10 w-full max-w-3xl p-12 rounded-[45px] shadow-2xl mx-auto text-center"
        style={{ background: cardBackground }}
      >
        {/* MINI HEADING WITH LINES */}
        <div className="flex flex-col items-center justify-center mb-6">
          <div
            className="h-[2px] mb-2"
            style={{
              width: "fit-content",
              minWidth: "50%",
              backgroundColor: about.mini_heading_color,
            }}
          ></div>

          <p
            className="uppercase font-semibold tracking-wider text-[14px] text-center whitespace-nowrap"
            style={{ color: about.mini_heading_color }}
          >
            {about.mini_heading}
          </p>

          <div
            className="h-[2px] mt-2"
            style={{
              width: "fit-content",
              minWidth: "50%",
              backgroundColor: about.mini_heading_color,
            }}
          ></div>
        </div>

        {/* MAIN HEADING */}
        <h2
          className="text-[44px] font-bold leading-[1.2] mb-6 text-center"
          style={{ color: about.heading_color }}
        >
          {about.heading}
        </h2>

        {/* DESCRIPTION */}
        <p
          className="text-[16px] leading-relaxed mx-auto max-w-[90%] text-center"
          style={{ color: about.heading_color }}
        >
          {about.description}
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
